function getConfigurationHubObjectParsed<objectType>(
  jsonObject?: string | object
): objectType | undefined {
  if (typeof jsonObject === "string") {
    jsonObject = `${jsonObject}`;
    if (jsonObject.startsWith("'")) {
      jsonObject = jsonObject.substring(
        jsonObject.indexOf("'") + 1,
        jsonObject.lastIndexOf("'")
      );
    }
    try {
      const jsonObjectParsed = JSON.parse(jsonObject) as objectType;
      return jsonObjectParsed;
    } catch (e) {
      throw new Error(
        `Error to getConfigurationHubObjectParsed. jsonObject: ${jsonObject}. ERROR: ${e}`
      );
    }
  } else if (typeof jsonObject === "object") {
    return jsonObject as unknown as objectType;
  }
}

export { getConfigurationHubObjectParsed };
